import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Input,
  InputAdornment,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
} from "@mui/material";
import { DateIconSvg, ListIconSvg, PersonIconSvg } from "../../images/SvgIcons";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function AttachConfirmation(props) {
  const { open, detachFunCall, handleClose, attachDettachLoading } = props;
  // const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [personName, setPersonName] = React.useState([]);
  const handleYes = () => {
    detachFunCall();
  };
  return (
    <>
      <Dialog
        className="user-filter-popup detach-model"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        // onClose={resetFilter}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "26px 34px", pb: "8px" }}
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          <Typography className="model-title">Attach this Statement</Typography>
        </Stack>
        <Box sx={{ p: "0px 34px 0px 34px" }}>
          <p className="detach-subtext">
            Are you sure you want to attach this statement?
          </p>
          <Box className="info-box">
            <p className="title">Note :</p>
            <p className="text">
              This will import all details from this billing statement into this
              invoice.
            </p>
          </Box>
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "20px 34px", pt: "25px" }}
        >
          <Button
            disabled={attachDettachLoading}
            className={
              attachDettachLoading ? "disable-filter-btn" : "filter-btn"
            }
            onClick={detachFunCall}
          >
            {attachDettachLoading && (
              <CircularProgress
                color={"inherit"}
                size={10}
                sx={{ marginRight: "3px" }}
              />
            )}
            Ok
          </Button>
          <Button className="cancel-btn" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
